import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { IRespAnamnesis } from '../../interfaces/anamnesis.interface';

@Injectable({
  providedIn: 'root',
})
export class AnamnesisService {
  private readonly clientId = '4b9b9ab5b734408d915ec31751bbf114';

  private readonly httpClient = inject(HttpClient);

  guardar(data: any): Observable<any> {
    const params = new HttpParams().set('client-id', this.clientId);

    return this.httpClient.post<any>(
      environment.baseURL + 'ficha-clinica/anamnesis',
      data,
      {
        params,
      }
    );
  }

  obtener(idAgendamiento: string): Observable<IRespAnamnesis> {
    const params = new HttpParams().set('client-id', this.clientId);

    return this.httpClient.get<IRespAnamnesis>(
      `${environment.baseURL}ficha-clinica/anamnesis/${idAgendamiento}`,
      {
        params,
      }
    );
  }
}
